import React from "react";
import { Loader } from "@components/ui/Loader";

const LoadingOverLay = () => {
  return (
    <div className="w-screen h-screen fixed top-0 left-0 bottom-0 right-0 bg-gray-300/50 flex justify-center items-center z-[9999]">
      <Loader texts={[""]} />
    </div>
  );
};

export default LoadingOverLay;
